import axios from 'axios';

const API_BASE_URL = 'https://routeiq.tracking.refexmobility.com'; // Replace with your actual API base URL

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'client-id': 'fleetiq',
    'client-secret': '5ag2sysmi6ufr6tf0mhy46frf9ep20bl',
  },
  timeout: 60000,
});

export const planRoute = async (employeeList, destinationLocation) => {
  try {
    const response = await api.post('/api/v1/route/plan-route', {
      employeeList,
      destinationLocation,
    });
    return response.data;
  } catch (error) {
    console.error('Error planning route:', error);
    throw error;
  }
};

export const optimizeTour = async ({ file, vehicleFile, officeLocation, date, googleProjectId, authToken }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('vehicleFile', vehicleFile);
  formData.append('officeLocation', JSON.stringify(officeLocation));
  formData.append('date', date);
  formData.append('googleProjectId', googleProjectId);
  formData.append('authToken', authToken);

  try {
    const response = await api.post('/api/v1/route/optimize-tour', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 180000,
    });
    return response.data;
  } catch (error) {
    console.error('Error optimizing tour:', error);
    throw error;
  }
};

export default api;
